import React from 'react'
import MaterialSymbol from '../material-symbol'

const AssignmentInd = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="assignment_ind" {...props} />
))

AssignmentInd.displayName = 'AssignmentInd'

export default AssignmentInd
